import React from 'react';

import DrawerMenu from '../containers/DrawerMenu';
import Header from './Header';
import CreatingAccount from './CreatingAccount';
import withStyles from '@material-ui/core/styles/withStyles';
import MessagesSnacks from './MessagesSnacks';
import MessagesDialog from './MessagesDialog';

/**
 * Default app layout, with header, footer and creating account modal
 */

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex:1,
  },
  toolbar: theme.mixins.toolbar,
  sub: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
    flex: 1,
    overflow: 'auto'
  },
  content: {
    flexGrow:1,
    flex:1,
    overflow:'auto',
  },
  contentDisplay: {
    maxWidth: 1248,
    margin: 'auto',
    padding: 16,
    marginBottom: 60
  },
});

const DashboardLayout = ({ title, classes, children, banner, visible, specificSelectedColor }) => (
  <div className={classes.root} >
    <Header title={title} />
    <div className={classes.toolbar} />
    <div className={classes.sub} >
      <DrawerMenu visible={visible} specificSelectedColor={specificSelectedColor} />
      <div className={classes.content} >
        {banner}
        <div className={classes.contentDisplay}>
          {children}
        </div>
      </div>
    </div>
    <CreatingAccount />
    <MessagesDialog />
    <MessagesSnacks />
  </div>
);

export default withStyles(styles)(DashboardLayout);


// WEBPACK FOOTER //
// ./src/components/DashboardLayout.js